import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Attachments, DescriptionWrapper } from "~/components/ModalObjects";
import TemplateDiscussionAndNoteHeader from "./TemplateDiscussionAndNoteHeader";
import { PROJECT_TEMPLATE_DISCUSSION } from "../utils";

export const TemplateDiscussionAndNoteBody = ({ element }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const elementType = useMemo(() => element?.type || element?.class, [element?.class, element?.type]);
  const bodyPlaceholderText = useMemo(
    () =>
      elementType === PROJECT_TEMPLATE_DISCUSSION
        ? t("This discussion has no description")
        : t("This note has no description"),
    [elementType, t]
  );

  const handleDblClick = useCallback(() => {
    navigate(location.pathname + location.search, {
      replace: true,
      state: { edit: true },
    });
  }, [location.pathname, location.search, navigate]);

  return (
    <>
      <TemplateDiscussionAndNoteHeader
        element={element}
        className="tw-mb-6"
      />
      <DescriptionWrapper
        parentId={element?.id}
        parentType={elementType}
        body={element?.body_formatted.length ? element?.body_formatted : bodyPlaceholderText}
        className="tw-mb-4 tw-border-b tw-border-solid tw-border-0 tw-border-border-primary tw-pb-4"
        onDoubleClick={handleDblClick}
      />
      {element?.attachments.length > 0 ? (
        <Attachments
          id={element.id}
          type={elementType}
          className="tw-mb-4 tw-border-b tw-border-solid tw-border-0 tw-border-border-primary"
        />
      ) : null}
    </>
  );
};

TemplateDiscussionAndNoteBody.propTypes = {
  element: PropTypes.object,
};
